// removed by extract-text-webpack-plugin
module.exports = {"container":"MenuOption__container___3CzhY"};